module.exports = __webpack_public_path__ + "static/media/portfolio.c0f4abfc.svg";